const SECRET_KEYS = /^(apiKey|authorization|authToken|pairingKey|token|pin|switchId|secret)s?$/i;
const URL_KEYS = /(?:urls?|uris?)$/i;
const LARGE_KEYS = /^(data|content)$/i;
const MAX_STRING = 512;

export function redact(value: unknown, key = ''): unknown {
  if (SECRET_KEYS.test(key)) return '[REDACTED]';
  if (typeof value === 'string') {
    if (URL_KEYS.test(key)) return redactUrl(value);
    if (LARGE_KEYS.test(key) && value.length > MAX_STRING) {
      return `[OMITTED ${value.length} chars]`;
    }
    return value.length > 4096 ? `[OMITTED ${value.length} chars]` : value;
  }
  if (Array.isArray(value)) return value.map((entry) => redact(entry, key));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([entryKey, entryValue]) => [
        entryKey,
        redact(entryValue, entryKey),
      ]),
    );
  }
  return value;
}

function redactUrl(value: string): string {
  try {
    const url = new URL(value);
    url.username = '';
    url.password = '';
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch {
    return '[REDACTED URL]';
  }
}
